import { memo } from 'react';

import Link from 'next/link';

import { buttonVariants } from '@/components/ui/button';

import {
	SWITCH_MAILTO,
	SWITCH_MIGRATION_HOURS,
} from '@/features/marketing/constants/switch-content';

import { COPY } from '@/shared/constants/copies';
import { APP_ROUTES } from '@/shared/constants/navigation';

import { cn } from '@/lib/utils';

/**
 * The switching offer, shown between the plan cards and the compare table on
 * /pricing and /plans. Same card as the compare pages' switch section, sized to
 * this page's compact plan cards; the primary CTA goes to /switch and the mailto
 * is the shortcut for someone ready to talk.
 */
export const SwitchOfferCard = memo(function SwitchOfferCard() {
	return (
		<section className="mt-8 rounded-lg border border-slate-200 bg-white p-5 shadow-sm md:p-6">
			<h2 className="mb-2 text-base font-semibold tracking-tight text-primary md:text-lg">
				{COPY.pricing.switchOfferTitle}
			</h2>
			<p className="max-w-3xl text-sm leading-6 text-secondary md:text-[15px]">
				{COPY.pricing.switchOfferDescription(SWITCH_MIGRATION_HOURS)}
			</p>
			<div className="mt-5 flex flex-wrap items-center gap-3">
				<Link
					href={APP_ROUTES.SWITCH}
					className={cn(
						buttonVariants(),
						'h-10 w-auto px-4 text-sm transition-all hover:translate-y-0.5'
					)}
				>
					{COPY.pricing.switchHowItWorksCta}
				</Link>
				<a
					href={SWITCH_MAILTO}
					className={cn(buttonVariants({ variant: 'outline' }), 'h-10 w-auto px-4 text-sm')}
				>
					{COPY.pricing.switchTalkToUsCta}
				</a>
			</div>
		</section>
	);
});
